<template>
  <div>
    <div>
      <div class="py-3 city-class">
        <div class="city-item-class pa-3 text-center">
          <v-btn
              block
              elevation="2"
              @click="change(0,'不限地区')"
          >
            不限地区
          </v-btn>
        </div>
      </div>
    </div>

    <div v-for="(item,index) in data" :key="index">
      <div class="text-h5 px-3">
        {{ item.name }}
      </div>
      <div class="py-3 city-class">
        <div class="city-item-class pa-3 text-center" v-for="(t,i) in item.subLevelModelList" :key="i">
          <v-btn
              width="100%"
              block
              elevation="2"
              @click="change(t.code,t.name)"
          >
            {{ t.name }}
          </v-btn>
        </div>
      </div>
    </div>

    <!--    底部-->

  </div>
</template>

<script>
export default {
  name: "city",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    change(code, name) {
      this.$emit('change', code, name)
    }
  }
}
</script>

<style scoped>
.city-class {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: center;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
}

.city-item-class {
  width: 25%;
}

/*.city-item-class:after {*/
/*  content: "";*/
/*  width: 25%;*/
/*}*/

/* 一行四列多余两个 */
.city-item-class:last-child:nth-child(4n+2) {
  margin-right: calc((100% - 25%) / 3 * 2);
}

/* 一行四列多余三个 */
.city-item-class:last-child:nth-child(4n+3) {
  margin-right: calc((100% - 25%) / 3 * 1);
}


</style>